<div class="container">
    <div class="container-table">
        <h1>
            CONFIGURACIÓN
        </h1>
        <table>
            <tr>
                <td>
                    Número de serie de la tablet.
                </td>
                <td>
                    <input type="text" [(ngModel)]="serial">
                </td>
            </tr>
            <tr>
                <td>
                    Número de cupones 10% de descuento.
                </td>
                <td>
                    <input type="number" [(ngModel)]="data.cubrebocas.n">
                </td>
            </tr>
            <tr>
                <td>
                    Número de cupones 15% de descuento.
                </td>
                <td>
                    <input type="number" [(ngModel)]="data.desc10.n">
                </td>
            </tr>
            <tr>
                <td>
                    Número de cubrebocas.
                </td>
                <td>
                    <input type="number" [(ngModel)]="data.desc15.n">
                </td>
            </tr>
            <tr>
                <td>
                   Hora de inicio (Solo cambiar al inicio del día).
                </td>
                <td>
                    <input type="text" [(ngModel)]="data.hora_inicio">
                </td>
            </tr>
            <tr></tr>
            <tr></tr>
            <tr>
                <td>
                    
                </td>
                <td style="text-align: end;">
                    <button (click)="guardar()">GUARDAR</button>
                </td>
            </tr>
        </table>
    </div>
</div>

<a (click)="goToHome()">
    <div class="text-2-container">
        <img class="arrow-right" src="../../assets/arrow-right.png" alt="logo">
        <span class="text-2">
            Regresar al inicio
        </span>
    </div>
</a>